import axios from '@/common/axios'

export const districts = (params) => {
    return axios.get(`site/config/districts`, params)
}

export const action = (params) => {
    return axios.get(`site/config/actions`, {params})
}

export const content = (params) => {
    return axios.get(`site/config/template/data`, {params})
}

export const schdistrictquery = (params) => {
    return axios.post(`site/app/schDistrict/getResult`, params)
}

export const stuposition = (params) => {
    return axios.post(`site/stuposition/search`, params)
}

export const infoList = (params)=>{
    return axios.get(`site/app/infoList`, {params})
}

export const getEnclosureListByInfoId = (params)=>{
    return axios.get(`site/app/getEnclosureListByInfoId`, {params})
}

export const getInfoListByOrgId= (params)=>{
    return axios.get(`site/app/getInfoListByOrgId`, {params})
}

export const infoDetail = (params)=>{
    return axios.get(`site/app/infoDetail`, {params})
}

export const policeList = (params)=>{
    return axios.get(`site/app/schDistrict/policeList`, {params})
}

export const committeeList = (params)=>{
    return axios.get(`site/app/schDistrict/committeeList`, {params})
}

export const SchDistrictDataList = (params)=>{
    return axios.get(`site/app/schDistrict/defaultData`, {params})
}

export const gradeSurplusDegree = (params)=>{
    return axios.get(`site/transferMap/gradeSurplusDegree`, {params})
}

export const schoolMarkerList = (params)=>{
    return axios.get(`site/warnMap/schoolMarkerList`, {params})
}

export const schoolInfoById = (params)=>{
    return axios.get(`site/warnMap/schoolInfoById`, {params})
}

export const searchSchool = (params)=>{
    return axios.get(`site/warnMap/searchSchool`, {params})
}

export const selectVillage = (params)=>{
    return axios.get(`site/stuposition/selectVillage`, {params})
}


